import React, { type InputHTMLAttributes } from "react";

import classNames from "classnames";

import style from "./Switch.module.css";

export const Switch = React.forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ ...attrs }, ref) => {
    return (
      <input
        {...attrs}
        ref={ref}
        type="checkbox"
        className={classNames(style.switch, attrs.className)}
      />
    );
  }
);

Switch.displayName = "Switch";
